// extracted by mini-css-extract-plugin
export default {"tabbingDataWrap":"QuantitiesVarianceReportDetails_tabbingDataWrap__eOaLq"};